import {
    GET_TOPIC, GET_ALL_TOPIC_WEIGHTS, UPDATE_TOPIC,
} from './actions';
import {
    SET_TOPIC, SET_ALL_TOPIC_WEIGHTS,
} from './mutations';
import HTTP from './../lib/HTTP';

const state = {
    item: null,
    weights: null,
};

const mutations = {
    [SET_TOPIC](_state, topic) {
        _state.item = topic;
    },
    [SET_ALL_TOPIC_WEIGHTS](_state, weights) {
        _state.weights = weights;
    }
};

const actions = {
    [GET_TOPIC](context, topicId) {
        return new Promise((resolve, reject) => {
            HTTP.get(`topics/${topicId}`).then((res) => {
                if (res && res.data) {
                    context.commit(SET_TOPIC, res.data);
                }
                resolve(res);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    [GET_ALL_TOPIC_WEIGHTS](context) {
        return new Promise((resolve, reject) => {
            HTTP.get(`topics/weights`).then((res) => {
                if (res && res.data) {
                    context.commit(SET_ALL_TOPIC_WEIGHTS, res.data);
                }
                resolve(res);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    [UPDATE_TOPIC](context, topic) {
        return new Promise((resolve, reject) => {
            HTTP.patch(`topics/${topic.id}`, topic).then((res) => {
                if (res && res.status === 204) {
                    context.commit(SET_TOPIC, null);
                    context.dispatch(GET_TOPIC, topic.id);
                }
                resolve(res);
            }).catch((err) => {
                reject(err);
            });
        });
    }
};

export default {
    state,
    mutations,
    actions,
};
